import React from 'react';
import { Box, TextField, InputAdornment, Divider } from '@mui/material';
import { FaSearch } from 'react-icons/fa';
import { ReviewType, FeedbackSessionStatus } from '../../common/filters';
import { FEEDBACK_SESSION_STATUS_FILTERS } from '../../../constants/feedbackSessionStatuses';

const MyFeedbackResultsFilters = ({
  searchTerm,
  onSearchChange,
  selectedStatuses,
  onStatusToggle,
  selectedReviewTypes,
  onReviewTypeToggle,
}) => {
  return (
    <Box sx={{
      display: 'flex',
      gap: '16px',
      flexWrap: 'wrap',
      width: '100%',
      alignItems: 'center',
    }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flex: 1,
        flexWrap: 'wrap'
      }}>
        <TextField
          placeholder="Search Sessions"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          autoComplete="off"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <FaSearch style={{ color: '#6B7280' }} />
                </InputAdornment>
              ),
            }
          }}
          sx={{
            width: '300px',
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
              height: '40px',
              fontSize: '14px',
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#2563eb',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#2563eb',
              }
            },
            '& .MuiInputBase-input': {
              padding: '8px 14px',
            }
          }}
        />

        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {/* Status filters */}
          <FeedbackSessionStatus
            selectedStatuses={selectedStatuses}
            onStatusToggle={onStatusToggle}
            statuses={[
              FEEDBACK_SESSION_STATUS_FILTERS.COMPLETED,
              FEEDBACK_SESSION_STATUS_FILTERS.CLOSED_WITH_INCOMPLETE,
              FEEDBACK_SESSION_STATUS_FILTERS.IN_PROGRESS
            ]}
          />

          {/* Vertical Divider */}
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              height: '32px',
              mx: 1,
              borderColor: '#CBD5E1'
            }}
          />

          {/* Review Type Filters */}
          <ReviewType
            selectedReviewTypes={selectedReviewTypes}
            onReviewTypeToggle={onReviewTypeToggle}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default MyFeedbackResultsFilters;
